<template>
  <div class="goodsDesc">
    <el-row>
      <el-col :span="24">
        <p class="goodsTitle" >{{ goodsData.name }}</p>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-carousel type="card"  :interval="500000" arrow="always">
          <el-carousel-item  style="display: flex;justify-content: center" v-for="(item,index) in goodsData.images" :key="index">
            <el-image
              style="height: 100%"
              :src="item"
              fit="contain"
              :preview-src-list="goodsData.images">
            </el-image>
          </el-carousel-item>
        </el-carousel>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24" style="box-sizing: border-box;padding: 20px 10% 10px 10%">
        <el-tabs v-model="activeName">
          <el-tab-pane label="产品参数" name="first">
            <p v-html="goodsData.cs"></p>
          </el-tab-pane>
          <el-tab-pane label="产品详情" name="second">
            <p v-html="goodsData.cdesc"></p>
          </el-tab-pane>
          <el-tab-pane label="咨询产品" name="third">
              <Concat :concatName="'产品：”'+goodsData.typename+'-'+goodsData.name+'“咨询'"/>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import  Concat from '@/components/common_concat';
export default {
  name: 'goodsDesc',
  components:{Concat},
  data() {
    return {
      activeName: 'first',
      goodsData:{},
      goodsID:null
    }
  },
  methods:{
    // 查询商品数据
    getData(goodsID){
      let _this = this;
      this.$axios.get('/fantis/goodsinfo/ftCmsGoodsInfo/queryById?id='+goodsID)
        .then(function(res){ // 请求成功 HTTP状态码是200
          if(res.data.code == 200){
            var tempData = res.data.result;

            // 如果有多张图片
            var imgArr = tempData.images.split(",");
            for(var c in imgArr){
              if(imgArr[c].startsWith('//') || imgArr[c].startsWith('https://') || imgArr[c].startsWith('http://')){

              }else{
                imgArr[c] = _this.$fileDPath + imgArr[c];
              }
            }

            tempData.images = imgArr;

            _this.goodsData = tempData;

          }else{
            _this.$message.error(res.data.msg);
          }
        })
        .catch(function (error) { // 请求失败处理
          console.log(error);
        });
    }
  },
  created() {
    this.goodsID = this.$route.query.goodsID;
    // 查询数据
    this.getData(this.goodsID);
  }
}
</script>

<style scoped>
.goodsTitle{
  font-size: 20px;
  line-height: 1.35;
  margin: 12px 0 12px 0;
  color: #333;
  text-align: center;
  font-weight: bolder;
}

.eimgH{
  height: 800px;
}

.el-carousel--horizontal {
  overflow: hidden;
  height: 800px;
}

/deep/ .el-carousel__container {
  position: relative;
  height: 100% !important;
}

/deep/ .is-in-stage img{
  filter: brightness(0.5);
}

/deep/ .is-active  img{
  filter: brightness(1);
}

@media only screen and (max-width: 800px) {
  .el-carousel--horizontal {
    overflow: hidden;
    height: 300px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/views/goods/goodsDesc.vue